module.exports = __webpack_public_path__ + "img/mi2.556c1c81.png";